import classnames from "classnames";

import style from "./style.module.scss";
import ControlBase from "../control-base";
import type { ControlSelectProps } from "../../types";

function ControlSelect({ label, touched, options, error, ...props }: ControlSelectProps) {
  return (
    <ControlBase label={label} touched={touched} error={error}>
      {(id) => (
        <select
          className={classnames(style.select, {
            [style.hasError]: error && touched,
          })}
          id={id}
          {...props}
        >
          {options.map((option, index) => (
            <option key={`${option.value}-${index}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      )}
    </ControlBase>
  );
}

export default ControlSelect;
